<template>
    <crud-create
        :open="open"
        :loading="loading"
        title="Crear Plan"
        :errorMessage="errorMessage"
        @create="create"
        @close="$emit('close')"
    >
        <plan-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>
import PlanProvider from '../../../providers/PlanProvider'
import { CrudCreate } from '@dracul/common-frontend'
import { ClientError } from '../../../../../errors'
import PlanForm from '../PlanForm'

export default {
    name: 'PlanCreate',
    components: { PlanForm, CrudCreate },
    props: {
        open: { type: Boolean, default: true }
    },
    data() {
        return {
            errorMessage: '',
            inputErrors: {},
            loading: false,
            form: {
                nombre: '',
                descripcion: '',
                active: true,
                roleTemplates: []
            }
        }
    },
    methods: {
        create() {
            if (this.$refs.form.validate()) {
                this.loading = true
                PlanProvider.createPlan(this.form)
                    .then(r => {
                        if (r) {
                            this.$emit('planCreated', r.data.adminPlanCreate)
                            this.$emit('close')
                        }
                    })
                    .catch(error => {
                        let clientError = new ClientError(error)
                        this.inputErrors = clientError.inputErrors
                        this.errorMessage = clientError.i18nMessage
                    })
                    .finally(() => this.loading = false)
            }
        }
    }
}
</script>
